<template>
  <div class="container" style="background:#fff;padding:0px; ">
      <topOp > </topOp>
      <div class="row">
        <div class="col-md-12">
          <div class="horasExtras">        
            <h3 style="font-style:italic;font-weight: 700;">
              Horas Extras
            </h3>
           <div class="formAjuste" >
             
             <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:386px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- Informar o valor do salário contratual recebido mensalmente.' " >
               
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div> 
              <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:455px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- Informar a carga horária semanal.\n A jornada normal do empregado urbano, rural ou doméstico, quando a lei ou a norma coletiva de trabalho não definir outro limite, pode ser contratada até o limite de 44 horas semanais e de 8 horas diárias. (Constituição Federal, art. 7°, inc. XIII).' " >
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div>    
              <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:522px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- Valor calculado automaticamente pelo sistema.\n\n  Corresponde à divisão do salário mensal pela jornada de trabalho mensal.\n Exemplo: R$ 1.500,00 / 220 h = R$ 6,82' " >
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div>    
              <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:590px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- Consideram-se horas extras as horas trabalhadas além da jornada normal diária contratada.\n A remuneração do serviço extraordinário é de, no mínimo, 50% (cinquenta por cento) superior à da hora normal (Constituição Federal, art. 7º, inc. XVI).\n  Referente ao trabalho realizado em dias de repouso semanal e de feriado, o adicional é de, no mínimo, 100% (cem por cento).\n\n Deverá ser observada, se houver, previsão mais benéfica ao empregado em Acordo Coletivo, Convenção Coletiva ou Sentença Normativa.'" >
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div>       
             <p style="text-align:left;margin-bottom:-11px;padding:0px;">Mês/Ano<p>  
             <label class="sr-only" >Mes</label>  
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-calendar" style="color:#808080;"></i></div>
                </div>
                <input type="text" class="form-control formatacaoInput" maxlength="7" v-model="mesAno" placeholder="MM/AAAA">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Quantidade Horas Extras<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">access_time</i></div>
                </div>
                <input type="text" class="form-control formatacaoInput" v-model="quantidadeHorasExtras">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Nº de feriados do mês<p>                           
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text" ><i class="fa fa-calendar-check-o" style="color:#808080;"></i></div>
                </div>                
                <input type="text" v-model="feriadosMes" class="form-control formatacaoInput">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;"> Salário Mensal<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">attach_money</i></div>
                </div>
                 <money  class="form-control formatacaoInput" v-model="salario" v-bind="money" @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money> 
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Jornada Semanal<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">access_time</i></div>
                </div>
                <input type="text" class="form-control formatacaoInput" v-model="jornadaSemanal">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Valor Hora<p>            
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">attach_money</i></div>
                </div>
                <input  class="form-control formatacaoInput" v-model="valorHora" disabled>
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">% Adicional<p>           
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class='fas fa-percentage' style="color:#808080;"></i></div>
                </div>
                <money  class="form-control formatacaoInput" v-model="adicional" v-bind="porcentagem"></money>
              </div>
              <div  v-if="exibirCheck" style="text-align:left;margin-top:16px;">                  
                <div @click="exibirCheck = !exibirCheck" style="width: 25px; cursor:pointer; 
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;margin-bottom:35px;"><i class="fa fa-check"  style="font-size:17px;margin-left:3px;"></i></div> calcular DSR                  
              </div>
              <div @click="exibirCheck = !exibirCheck" v-else  style="text-align:left;margin-top:16px;"> 
                <div style="width: 25px; cursor:pointer;
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;margin-bottom:35px;"><span style="font-size:1px;">.</span></div> Calcular DSR              
              </div>
              <button class="limpar" @click="limpar()">Limpar</button> <a href="#horasExtrasResultado1"><button :disabled="disabled" class="calcular" @click="calcular()" >calcular <b-spinner v-show="spiner" style="width: 1.5rem;
height: 1.5rem;" small></b-spinner> </button></a>
              <br>
              <br>
              <span style="color:red;" v-show="erro">Erro no cálculo. Por favor revise os campos!</span>
              <br>
            </div>
          </div>
        </div>
      </div>
      <div class="horasExtrasResultado"  id="horasExtrasResultado1" style="background:#BEBEBE;">
            <h3 style="font-style:italic;">
              Resultado do Cálculo
            </h3>  
             <div id="formAjuste2" > 
              <p class="pResult"> Valor Hora Extra:</p>
              <input type="text"  class="resultHorasExtras" :value="resultadoHoraExtra" disabled>
               <p class="pResult"> Valor DSR:</p>
              <input type="text" class="resultHorasExtras"  :value="resultadoValorDSR" disabled>
               <p class="pResult"> Dias Úteis:</p>
              <input type="text" class="resultHorasExtras"  :value="resultadoDiasUteis" disabled>
               <p class="pResult"> Domingos e Feriados:</p>
              <input type="text" class="resultHorasExtras"  :value="resultadoDomingosFeriados" disabled>              
             </div>
        </div>
  </div>
</template>

<script>
import services from '../services/services.js'
 import {Money} from 'v-money';
import topOp from '../shared/topOp.vue';

export default {  
  components:{
    'topOp':topOp,
    Money 
  },
  data(){
    return {
      price:'',
      disabled:false,
      spiner:false,
      exibirCheck:false,
      mesAno:'',
      feriadosMes:0,
      salario:0,
      jornadaSemanal:0,
      valorHora:null,
      adicional:0,
      quantidadeHorasExtras:0,      
        money: {
          decimal: ',', 
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
        porcentagem:{
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        resultadoHoraExtra:null,
        resultadoDiasUteis:null,
        resultadoValorDSR:null,
        resultadoDomingosFeriados:null,
        resCalculoHoraExtra:[],
        erro:false
    }
  },
  methods:{   
    async calcular(){
     this.spiner = true
     this.resCalculoHoraExtra = await services.getCalcularHoraExtra(this.mesAno,this.feriadosMes,this.salario,this.jornadaSemanal,this.adicional,this.exibirCheck,this.quantidadeHorasExtras);
      if(this.resCalculoHoraExtra == undefined){
        this.spiner = true
        this.spiner = false;
        this.erro = true
        return;
      }
   
        this.resultadoHoraExtra = this.resCalculoHoraExtra.valorHoraExtra;
        this.resultadoValorDSR = this.resCalculoHoraExtra.valorDSR;
        this.resultadoDiasUteis = this.resCalculoHoraExtra.diasUteis;
        this.valorHora = this.resCalculoHoraExtra.valorHora;
        this.resultadoDomingosFeriados = this.resCalculoHoraExtra.domingosFeriado;
        this.spiner = false;
        this.erro = false;
      
    },
    limpar(){
      this.mesAno ='';
      this.feriadosMes =0;
      this.salario = 0;
      this.jornadaSemanal = 0;
      this.valorHora = null;
      this.adicional = 0;
      this.resultadoHoraExtra=null
      this.resultadoDiasUteis=null
      this.resultadoValorDSR=null
      this.resultadoDomingosFeriados=null
      this.exibirCheck = false;
      this.quantidadeHorasExtras=0;
       this.erro = false;
    }
  },
  watch:{
    mesAno(novo){                 
        if(novo.length == 3 && !(novo[(novo.length-1)] == '/')){
            this.mesAno = this.mesAno.replace(/(\d{2})/,"$1/")
        }            
        this.mesAno= this.mesAno.replace(/[A-Za-z]/, '')         
        this.mesAno= this.mesAno.replace(/[!@#$%¨&*)(+´^>}{.,|"<;:]/, '') 
        }
  },

}
</script>

<style>
div.input-group-text{
  border-left: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
.resultHorasExtras {
  width: 100%;
  max-width: 370px;
  height: 45px;
  border-radius: 10px;
  padding-left: 10px;
}
.container-flex {        
         display: flex;
         flex-direction: row;
         justify-content: center;
         align-items: center
     }
     .box {
         width: 360px;
        height: 45px;
         background: #fff;
     }
.resultado{
  width: 407px;
height: 45px;
background: #fff;
}
.pResult{
text-align:left;margin-bottom:5px;margin-top:10px;margin-left:2px;
}
.calcular{
   float: right;background: #FF7835 0% 0% no-repeat padding-box;
border: 2px solid #FF7835;
border-radius: 5px;width: 170px;
font-size:21px;
height: 48px;color:#fff;margin-top:-10px;font-weight: 600;cursor:pointer;
font-style:italic;
}
.calcular:hover{
  background: #e64d00;
  border:1px solid #e64d00;
}
.limpar{
  float: left;border: 2px solid #FF7835;
border-radius: 5px;background:#fff;padding:5px;font-weight: 500;font-size:15px;width: 105px;cursor:pointer;font-style:italic;
}

.limpar,
.calcular {
  width: 100%;
  max-width: 170px;
} 
input.formatacaoInput{
  /* border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-radius: 10px;
  height: 43px;
}

.horasExtras,
.horasExtrasResultado {
  padding: 30px 20px;
}
h3{
  border-bottom: 1px solid #707070;
  padding-bottom: 6px;
  text-align: left;
  font-weight: bold;
  font-size:26px;
}

.formAjuste{
  width: 370px;
  margin:0px auto;
  position: relative;
  top:-40px;
}
@media (min-width: 768px) {
  .horasExtras,
  .horasExtrasResultado {
    padding-left: 110px;
    padding-right: 110px;
  }
}
#formAjuste2 {
  width: 100%;
  max-width: 370px;
  margin: 20px auto;
}
input{
  border-right: 1px solid #707070;
    border-top: 1px solid #707070;
    border-bottom: 1px solid #707070;
}

@media (max-width: 490px) {
  .limpar {
    max-width: 88px;
  }

  .calcular {
    max-width: 126px;
    height: 37px;
  }

  .resultHorasExtras {
    height: 45px;
  }
}
</style>


// WEBPACK FOOTER //
// src/screens/HorasExtras.vue